const { io } = require("socket.io-client");

export const socket = io.connect(process.env.REACT_APP_SERVER_URL, {
    auth: {
        token: sessionStorage.getItem("token")
    }
});
